import { useState } from "react";
import { getDashboardStats } from "../api/dashboardApi";

const useDashboardStats = () => {
  const [statsData, setStatsData] = useState({});
  const [loading, setLoading] = useState(false);

  const getStatsData = async () => {
    try {
      setLoading(true);
      const res = await getDashboardStats();
      setStatsData(res?.data || {});
      return res;
    } catch (error) {
      console.error("error on get dashboard stats:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    getStatsData,
    statsData,
    loading,
  };
};

export default useDashboardStats;
